@if (weatherIcon(); as weatherIcon) {
  <svg-icon class="dark:[&&]:hidden" [key]="weatherIcon.lightIcon" [size]="iconSize()" />
  <svg-icon class="[&&]:hidden dark:[&&]:block" [key]="weatherIcon.darkIcon" [size]="iconSize()" />
  @if (details()) {
    <span class="ml-1 text-xs whitespace-nowrap">{{ weatherIcon.translationKey | translate }}</span>
  }
}
@if (details() && temperatureCelsius() !== null && temperatureCelsius() !== undefined) {
  <span class="ml-1 text-xs whitespace-nowrap">{{ temperatureCelsius() | number: '1.0-1' }}{{ 'common.celsius' | translate }}</span>
}
